/**
 * HUB-H — Carte événement sécurité.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import {
  formatEquipeDate,
  securityEventLabel,
} from '../../utils/equipe/equipeDisplay';

export default function ActiviteEquipeSecurityCard({ event, testIdPrefix = 'activite-equipe' }) {
  const label = securityEventLabel(event.type);
  const user = event.username || event.actor || '—';
  const at = event.created_at || event.timestamp;

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-security-${event.id || event.type}-${at}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-[var(--rm-white)] text-sm">{label}</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5 truncate">
            {event.details || event.path || event.ip || '—'}
          </p>
        </div>
        <span className="rm-badge rm-badge--muted">Sécurité</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
        <div>
          <span className="text-[var(--rm-gray-500)]">Date </span>
          <span className="text-[var(--rm-gray-300)]">{formatEquipeDate(at)}</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Utilisateur </span>
          <span className="text-[var(--rm-gray-300)]">{user}</span>
        </div>
        {event.ip && (
          <div>
            <span className="text-[var(--rm-gray-500)]">IP </span>
            <span className="font-mono text-xs text-[var(--rm-gray-300)]">{event.ip}</span>
          </div>
        )}
      </div>

      <div className="mt-2">
        <Link
          to="/admin/audit"
          className="text-xs text-[var(--rm-gray-400)] hover:text-[var(--rm-white)] inline-flex items-center gap-1 min-h-[44px] px-1"
          data-testid={`${testIdPrefix}-security-link-${event.type}`}
        >
          Monitoring complet
          <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </article>
  );
}
